import React from "react";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { Controller } from "react-hook-form";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { Input } from "../../../../components/form/Input/Input";

export const ChainFilters = ({
  isEditMode = false,
  control,
  register,
  isAddNewStoreDisabled,
  organizations = [],
  storeStatuses
}) => {
  return (
    <>
      <div className="chains__section">
        <Input label="Name" htmlFor="name" customProps={register("name")} placeholder="XPO" />
        <Input
          label="Uid"
          htmlFor="uid"
          customProps={register("uid", { disabled: isEditMode })}
          placeholder="622"
        />

        {!isEditMode ? (
          <div className="chains__dropdown">
            <p>Organization</p>
            <Controller
              control={control}
              name="organization_id"
              render={({ field: { onChange, onBlur, value } }) => {
                return (
                  <Dropdown
                    onBlur={onBlur}
                    height={275}
                    haveOnSelectChange
                    options={organizations}
                    selectedFilters={value}
                    numberDisplayed={0}
                    onSelectChange={(data) => onChange(data)}
                  />
                );
              }}
            />
          </div>
        ) : (
          <div className="chains__empty" />
        )}
      </div>

      <div className="chains__section">
        <div className="switch">
          <p className="switch__title">Add new stores</p>
          {isAddNewStoreDisabled ? (
            <div className="switch__content switch__content--disabled">
              <ToggleableButton isRadio title="addNewStore" isActive={false} onClick={() => null} />
            </div>
          ) : (
            <Controller
              control={control}
              name="add_new_store"
              render={({ field: { onChange, value } }) => {
                return (
                  <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                    <ToggleableButton
                      isRadio
                      title="addNewStore"
                      isActive={value}
                      onClick={(isActive) => onChange(isActive)}
                    />
                  </div>
                );
              }}
            />
          )}
        </div>

        <div className="chains__dropdown">
          <p>Active store statuses</p>
          <Controller
            control={control}
            name="active_store_statuses"
            render={({ field: { onChange, onBlur, value } }) => {
              return (
                <Dropdown
                  includeSelectAll
                  onBlur={onBlur}
                  height={275}
                  haveOnSelectChange
                  options={storeStatuses}
                  selectedFilters={value}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>

        <div className="chains__empty" />
      </div>
    </>
  );
};
